import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { CosignatureSupervisorsResponse } from "@/core/types";

import { cosignatureKeys } from "../keyFactory";
import { getCosignatureSupervisors } from "../queryFunctions/getCosignatureSupervisors";

type UseCosignatureSupervisorsProps<TData = CosignatureSupervisorsResponse> = {
  enabled?: boolean;
  select?: (data: CosignatureSupervisorsResponse) => TData;
};

type CosignatureSupervisorsQueryOptions = UseQueryOptions<
  CosignatureSupervisorsResponse,
  unknown,
  CosignatureSupervisorsResponse,
  ReturnType<typeof cosignatureKeys.supervisors>
>;

export function optionFactory(enabled = true) {
  return {
    enabled,
    queryFn: getCosignatureSupervisors,
    queryKey: cosignatureKeys.supervisors(),
    staleTime: Infinity,
  } satisfies CosignatureSupervisorsQueryOptions;
}

export function useCosignatureSupervisors<TData = CosignatureSupervisorsResponse>({
  enabled = true,
  select,
}: UseCosignatureSupervisorsProps<TData> = {}) {
  return useQuery({ ...optionFactory(enabled), select });
}
